<ng-container *ngIf="!loading && form">

  <!-- No custom fields configured for this module -->
  <ng-container *ngIf="!hasFields()"></ng-container>

  <!-- Render groups and fields -->
  <ng-container *ngFor="let group of schema.groups">

    <ng-container *ngIf="group.fields && group.fields.length > 0 && isGroupVisible(group)">

      <!-- Group header (only shown when there are multiple groups) -->
      <div *ngIf="schema.groups.length > 1 || !group.is_default" class="custom-field-group-header mb-2 mt-3">
        <span class="custom-field-group-label">{{ group.name }}</span>
      </div>

      <div class="grid" [formGroup]="form">
        <ng-container *ngFor="let field of group.fields">
          <ng-container *ngIf="(field.active || isDeleted(field)) && isVisible(field)">

            <!-- Switch: full-width row, label left, toggle right -->
            <ng-container *ngIf="field.field_type === 'switch'; else defaultFieldLayout">
              <div class="col-12 md:col-6 mb-3">
                <div class="cf-switch-row">
                  <label class="cf-switch-label">
                    {{ field.label }}
                    <span *ngIf="field.is_required && field.active" class="text-danger">*</span>
                    <span *ngIf="isDeleted(field)" class="cf-deleted-badge">Removed</span>
                  </label>
                  <p-inputSwitch [formControlName]="field.internal_name"></p-inputSwitch>
                </div>
                <small class="text-danger" *ngIf="getError(field)">{{ getError(field) }}</small>
              </div>
            </ng-container>

            <!-- All other field types -->
            <ng-template #defaultFieldLayout>
              <!-- Textarea: full width -->
              <div [class]="field.field_type === 'textarea' ? 'col-12 mb-3' : 'col-12 md:col-6 mb-3'">
                <div class="form-group">

                  <label class="form-label">
                    {{ field.label }}
                    <span *ngIf="field.is_required && field.active" class="text-danger">*</span>
                    <span *ngIf="isDeleted(field)" class="cf-deleted-badge">Removed</span>
                  </label>

                  <!-- TEXT -->
                  <ng-container *ngIf="field.field_type === 'text'">
                    <input
                      type="text"
                      pInputText
                      class="form-control"
                      [formControlName]="field.internal_name"
                      [placeholder]="field.placeholder || ''"
                      autocomplete="off"
                    />
                  </ng-container>

                  <!-- TEXTAREA -->
                  <ng-container *ngIf="field.field_type === 'textarea'">
                    <textarea
                      pInputTextarea
                      class="form-control"
                      [rows]="3"
                      [style]="{ width: '100%' }"
                      [formControlName]="field.internal_name"
                      [placeholder]="field.placeholder || ''"
                    ></textarea>
                  </ng-container>

                  <!-- NUMBER -->
                  <ng-container *ngIf="field.field_type === 'number'">
                    <p-inputNumber
                      [formControlName]="field.internal_name"
                      [placeholder]="field.placeholder || ''"
                      [min]="field.min_value !== null ? +field.min_value : null"
                      [max]="field.max_value !== null ? +field.max_value : null"
                      [useGrouping]="false"
                      styleClass="w-full"
                      inputStyleClass="form-control"
                    ></p-inputNumber>
                  </ng-container>

                  <!-- DATE -->
                  <ng-container *ngIf="field.field_type === 'date'">
                    <p-calendar
                      [formControlName]="field.internal_name"
                      [placeholder]="field.placeholder || 'Select date'"
                      dateFormat="dd/mm/yy"
                      [showIcon]="true"
                      appendTo="body"
                      [style]="{ width: '100%' }"
                      inputStyleClass="form-control"
                    ></p-calendar>
                  </ng-container>

                  <!-- DROPDOWN -->
                  <ng-container *ngIf="field.field_type === 'dropdown'">
                    <p-dropdown
                      [formControlName]="field.internal_name"
                      [options]="getOptionItems(field)"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="field.placeholder || 'Select...'"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                    ></p-dropdown>
                  </ng-container>

                  <!-- MULTI SELECT -->
                  <ng-container *ngIf="field.field_type === 'multi_select'">
                    <p-multiSelect
                      [formControlName]="field.internal_name"
                      [options]="getOptionItems(field)"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="field.placeholder || 'Select...'"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                      display="chip"
                    ></p-multiSelect>
                  </ng-container>

                  <!-- URL -->
                  <ng-container *ngIf="field.field_type === 'url'">
                    <input
                      type="url"
                      pInputText
                      class="form-control"
                      [formControlName]="field.internal_name"
                      [placeholder]="field.placeholder || 'https://'"
                      autocomplete="off"
                    />
                  </ng-container>

                  <!-- Validation error -->
                  <small class="text-danger" *ngIf="getError(field)">{{ getError(field) }}</small>

                </div>
              </div>
            </ng-template>

          </ng-container>
        </ng-container>
      </div>

    </ng-container>
  </ng-container>

</ng-container>

<!-- Loading skeleton -->
<ng-container *ngIf="loading">
  <div class="grid">
    <div class="md:col-6 mb-3" *ngFor="let i of [1, 2]">
      <p-skeleton height="2rem" styleClass="mb-1"></p-skeleton>
      <p-skeleton height="2.5rem"></p-skeleton>
    </div>
  </div>
</ng-container>
